import getReduxSelector from 'modules/redux/selectors/get'
import {
  POST_SAMPLE_SURVEY_KEY,
  POST_SAMPLE_SURVEY_PATH
} from 'modules/post-sample-survey/redux/state'

export default function getRemindersPostSampleSurveySelect (state) {
  const path = `${POST_SAMPLE_SURVEY_PATH[POST_SAMPLE_SURVEY_KEY.REMINDERS]}.data.survey_resp_reminders`
  return getReduxSelector(path)(state)
}
